module.exports = __webpack_public_path__ + "static/media/dr.b8d2fdd9.png";